import './App.css';
import {Home} from "./components/Home";
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {CacheProvider} from '@emotion/react';
import createCache from '@emotion/cache';
import {prefixer} from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import React, {useState} from "react";
import BusinessContext from "./contexts/BusinessContext";
import {Route, Routes} from "react-router-dom";
import {Login} from "./components/Login";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import {axiosInstance} from "./utils/axiosUtils";
import {TestModeSection} from "./components/TestModeSection";
import Button from "@mui/material/Button";

const theme = createTheme({
    direction: 'rtl',
    palette: {
        background: {
            paper: '#fff',
        },
        /*text: {
            primary: '#fff',
            secondary: '#46505A',
        },*/
        action: {
            active: '#001E3C',
        }
    },
});
const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});


function App() {
    const [showTestMode, setShowTestMode] = useState(false);
    const [shouldUpdateBusinessSettings, setShouldUpdateBusinessSettings] = useState(false);
    const [testMode, setTestMode] = useState(false);
    const [testNumber, setTestNumber] = useState();
    const [allowUpdateTestMode, setAllowUpdateTestMode] = useState(false);
    const [loader, setLoader] = useState(false);
    const deleteTestMessage = async () => {
        setLoader(true);
        await axiosInstance.delete('/Whatsapp/');
        setLoader(false);
    }

    const updateBusinessSettings = (mode,  number)=>{
        axiosInstance.post('/Business', {testMode: mode, testNumber: number}).then((response) => {
            setTestNumber(response.data.testNumber);
            setTestMode(response.data.testMode);
            setShouldUpdateBusinessSettings(true);
        });
    }
    const updateTestToggle = (e) => {
        setTestMode(e.target.checked);
        updateBusinessSettings(e.target.checked, testNumber);
    }
    const updateTestNumber = () => {
        updateBusinessSettings(testMode, testNumber);
    }
    return (
        <BusinessContext.Provider
            value={{showTestMode, setShowTestMode, testMode, setTestMode, testNumber, setTestNumber, shouldUpdateBusinessSettings, setShouldUpdateBusinessSettings, setAllowUpdateTestMode}}>
            <CacheProvider value={cacheRtl}>
                <ThemeProvider theme={theme}>
                    <div className="App">
                        <header className="App-header">
                            <div className='my-4 flex '>
                                <Grid container spacing={5}>
                                    <Grid item xs={3}>
                                        {showTestMode && <TestModeSection
                                            allowUpdateTestMode={allowUpdateTestMode}
                                            deleteTestMessage={deleteTestMessage}
                                            updateTestToggle={updateTestToggle}
                                            testMode={testMode}
                                            testNumber={testNumber}
                                            setTestNumber={setTestNumber}
                                            updateTestNumber={updateTestNumber}
                                            loader={loader}/>
                                        }
                                    </Grid>
                                    <Grid item xs={6}>
                                            <h1 className='h1'>Feedo</h1>
                                    </Grid>
                                    {/*<Grid item xs={3}>
                                        <Button variant="contained">סנכרן</Button>
                                    </Grid>*/}
                                </Grid>
                            </div>
                        </header>
                        <div className={"App-body"}>
                            <CssBaseline/>
                            <Routes>
                                <Route path="/login" element={<Login/>}/>
                                <Route path="/"
                                       element={<Home/>}/>
                            </Routes>
                        </div>
                    </div>
                </ThemeProvider>
            </CacheProvider>
        </BusinessContext.Provider>
    );
}

export default App;
